/* ===== ウィッシュリスト共通 ===== */
var CMP_WL = (function () {
  var KEY = 'cmp_wishlist';
  function get()       { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(e) { return []; } }
  function save(list)  { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e) {} }
  function has(id)     { return get().some(function(i) { return String(i.id) === String(id); }); }
  function add(item)   { var l = get(); if (!has(item.id)) { l.unshift(item); save(l); } }
  function remove(id)  { var l = get().filter(function(i) { return String(i.id) !== String(id); }); save(l); }
  function toggle(item){ has(item.id) ? remove(item.id) : add(item); }
  function count()     { return get().length; }
  return { get: get, has: has, add: add, remove: remove, toggle: toggle, count: count };
})();

/* ===== 商品ページのお気に入りボタン（全ページ読み込み） ===== */
document.addEventListener('DOMContentLoaded', function () {
  var btn = document.querySelector('.product__wishlist-btn');
  if (!btn) return;

  var id = btn.dataset.productId;

  function syncBtn() {
    var inList = CMP_WL.has(id);
    btn.classList.toggle('is-active', inList);
    var label = btn.querySelector('.product__wishlist-label');
    if (label) label.textContent = inList ? '追加済み' : 'お気に入り';
    btn.setAttribute('aria-label',
      (inList ? 'お気に入りから削除: ' : 'お気に入りに追加: ') + (btn.dataset.productTitle || '')
    );
  }

  syncBtn();

  btn.addEventListener('click', function () {
    CMP_WL.toggle({
      id:    id,
      url:   btn.dataset.productUrl,
      title: btn.dataset.productTitle,
      price: btn.dataset.productPrice,
      img:   btn.dataset.productImg
    });
    syncBtn();
  });
});
